import { ArrowRight } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const tiles = [
  {
    title: "Men",
    tag: "24 styles",
    href: "#men",
    image: "https://images.unsplash.com/photo-1520256862855-398228c41684?auto=format&fit=crop&w=1200&q=85",
  },
  {
    title: "Women",
    tag: "31 styles",
    href: "#women",
    image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?auto=format&fit=crop&w=1200&q=85",
  },
  {
    title: "Limited Drops",
    tag: "This month",
    href: "#collections",
    image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?auto=format&fit=crop&w=1200&q=85",
  },
];

export default function CategoryBanners() {
  const ref = useReveal();
  return (
    <section
      ref={ref}
      data-testid="category-section"
      className="reveal max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24"
      id="collections"
    >
      <div className="grid md:grid-cols-3 gap-4 md:gap-5">
        {tiles.map((t) => (
          <a
            key={t.title}
            href={t.href}
            data-testid={`category-tile-${t.title.replace(/\s+/g, "-").toLowerCase()}`}
            className="tile group aspect-[3/4] md:aspect-auto md:h-[520px]"
          >
            <img
              src={t.image}
              alt={`${t.title} collection lifestyle shot`}
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8 text-white">
              <span className="mono text-[10px] uppercase tracking-widest opacity-80">{t.tag}</span>
              <h3 className="font-display font-extrabold text-3xl md:text-4xl mt-1">{t.title}</h3>
              <span className="tile-cta mt-4 inline-flex items-center text-sm font-medium">
                Shop the collection
                <ArrowRight size={16} />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
